export default __webpack_public_path__ + "static/media/multiplication-app.2fdc46ac.png";